import * as React from 'react';
import moment from 'moment';

import { Typography } from 'components/v2';

interface IAppointmentItemHeader {
  appointmentTypeName: string;
  appointmentDate: Date;
  isAppointmentSelected: boolean;
}

const collapsedDateFormat = 'MM/DD h:mm A';
const expandedDateFormat = '[On] MM/DD [at] h:mm A';

const AppointmentItemHeader: React.FunctionComponent<IAppointmentItemHeader> = (props) => {
  const { appointmentTypeName, appointmentDate, isAppointmentSelected } = props;

  const formattedDate = moment(appointmentDate).format(
    isAppointmentSelected ? expandedDateFormat : collapsedDateFormat,
  );

  return (
    <>
      <Typography variant="bW600F14" noWrap>
        {appointmentTypeName}
      </Typography>
      <Typography variant="bW600F14" noWrap>
        {formattedDate}
      </Typography>
    </>
  );
};

export default AppointmentItemHeader;
